const HtmlContentStatus = {
  AUTH: 'auth',
  SHOW_REG_BANNER: 'showBanner',
  SHOW_WEBINAR: 'showWebinar',
  SHOW_QUESTIONNAIRE: 'showQuestionnaire',
  HIDE_CONTENT: 'hideContent',
  WITH_HORIZ_SCROLL: 'horizontalScroll',
}

export { HtmlContentStatus }
